const dashboardDE = {
    "view": {
        "label": {
            "allTimeSales": "Verkäufe insgesamt",
            "totalToBePaid": "Gesamtbetrag zur Zahlung",
            "promoCoins": "Promo-Münzen",
            "promoDownloadCount": "Promo-Download-Anzahl",
            "promoFeedbackCount": "Promo-Feedback-Anzahl",
            "totalDownloads": "Gesamte Downloads",
            "totalFeedbacks": "Gesamte Feedbacks"
        },
        "options": {
            "earnings": {
                "allTime": "Gesamteinnahmen",
                "last12Months": "Letzte 12 Monate"
            },
            "months": {
                "jan": "Jan",
                "feb": "Feb",
                "mar": "Mär",
                "apr": "Apr",
                "may": "Mai",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Aug",
                "sep": "Sep",
                "oct": "Okt",
                "nov": "Nov",
                "dec": "Dez"
            }
        },
        "message": {
            "userWelcomeTitle": "Hey {{firstName}}, willkommen zurück auf der Music Link Plattform.",
            "ownedAndManaged": "Ihr Konto wird von <1>{{ parent_company }}</1> verwaltet, besuchen Sie unsere <3>Hilfeseite</3>, um mehr zu erfahren.",
            "completeInformation": "Sie haben Ihre Informationen noch nicht eingereicht, bitte <1><strong>Vervollständigen Sie Ihre Informationen</strong></1>, um fortzufahren!",
            "notSubscribed": "Sie sind bei keinem Plan abonniert. Abonnieren Sie jetzt, um das volle Potenzial der Music Link Plattform freizuschalten!",
            "accountBlacklisted": "Ihr Konto wurde nach einer Überprüfung als schwarzlistet, da wir festgestellt haben, dass die Informationen, die mit Ihrem Konto verknüpft sind, mit einem internationalen schwarzlisteten Benutzer in unserem System verknüpft sind. Aus diesem Grund haben wir die Verteilungsfunktion für Ihr Konto deaktiviert.",
        }
    }
};

export default dashboardDE;